import { CheckCircle2 } from "lucide-react";
import { SITE } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import FlyWords from "./FlyWords";

const POINTS = [
  "Precision craftsmanship from concept to install",
  "Premium materials — natural stone, hardwoods, custom millwork",
  "Integrated LED lighting and clean cable management",
  "Transparent communication at every stage",
  "Built for homeowners, businesses, designers and investors",
  "Workmanship that protects and elevates your property value",
];

export default function About() {
  const ref = useReveal();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section bg-[#050505] relative"
      ref={ref}
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 reveal">
          <div className="relative">
            <div className="w-full aspect-square rounded-2xl border border-[#27272A] bg-gradient-to-br from-[#0a0a0a] via-[#111111] to-[#050505] flex items-center justify-center p-6 md:p-10 overflow-hidden">
              <div
                className="absolute inset-0 opacity-30 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(circle at 50% 50%, rgba(212,175,55,0.18) 0%, transparent 60%)",
                }}
              />
              <video
                data-testid="about-brand-video"
                src="https://customer-assets-agu9un31.emergentagent.net/job_luxury-walls-preview/artifacts/0hdiy6d8_AQMbaOSMe9LtA5_ph_kiGebHcjlPUIEV821PNXmtAkBn7kY1QDSAvdo9Wzd2Pjw_3cU63_4GOt2I4ZWswn9lCEw7HCiZwGJA7xYGbZRPpA.mp4"
                poster={SITE.logo}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                className="relative w-full max-w-md h-auto object-contain rounded-xl shadow-[0_0_60px_rgba(212,175,55,0.18)]"
              />
            </div>
            <div className="hidden md:block absolute -bottom-8 -right-8 bg-[#111111] border border-[#27272A] rounded-xl p-6 w-64 shadow-2xl">
              <div className="font-display text-4xl text-[#D4AF37]">Florida</div>
              <div className="text-xs uppercase tracking-[0.22em] text-[#A1A1AA] mt-2">
                Locally owned · Tampa Bay
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 reveal">
          <div className="overline mb-5">Why Swift</div>
          <FlyWords
            as="h2"
            className="font-display text-4xl md:text-5xl text-white font-light leading-tight"
            segments={[
              { text: "We don\u2019t just build walls \u2014" },
              { type: "break" },
              { text: "we craft experiences.", className: "italic text-[#D4AF37]" },
            ]}
          />
          <p className="mt-6 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            Every Swift project is carefully designed and built with precision
            craftsmanship, premium materials and meticulous attention to
            detail. Whether you&apos;re imagining a breathtaking living-room
            centerpiece, a sophisticated office feature wall, or a one-of-a-kind
            luxury installation — we tailor every detail to your space and
            style.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p, i) => (
              <li
                key={i}
                data-testid={`about-point-${i}`}
                className="flex items-start gap-3 text-sm text-[#D1D1D6]"
              >
                <CheckCircle2 className="h-5 w-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
